import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SettingsModel')
export default class SettingsModel {
  @JsonProperty('ident', String) public ident:string = '';
  @JsonProperty('key', String) public key:string = '';
  @JsonProperty('name', String) public name:string = '';
}
